module.exports = __webpack_public_path__ + "static/media/Thermocycler-Medizintechnik.39ce7e25.png";